module.exports = __webpack_public_path__ + "resources/img/img-danbiAi.ab1387e37fbbdf8fe491f9c52bb15b52.png";